import React from "react";

// Shared phone-like bezel wrapper used to frame previews consistently
export const PhoneBezel: React.FC<{
  children: React.ReactNode;
  className?: string;
  /** Optional fixed inner screen height. If omitted or <= 0, height will auto-size to content. */
  screenHeight?: number;
}> = ({ children, className, screenHeight }) => {
  // Tailwind p-2 -> 8px padding on top and bottom
  const paddingPx = 8;
  const hasFixed = typeof screenHeight === 'number' && isFinite(screenHeight) && screenHeight > 0;
  // When consumers pass h-full on the bezel, prefer filling the parent instead of using a fixed height
  const wantsFull = !!(className && className.includes('h-full'));
  const innerHeight = hasFixed ? Math.max(0, (screenHeight as number) - paddingPx * 2) : undefined;
  return (
    <div className={`rounded-[28px] bg-gray-100 p-2 shadow-2xl ring-1 ring-black/10 ${className || ""} z-0`} style={wantsFull ? { height: '100%' } : undefined}>
      <div className="rounded-[22px] overflow-hidden bg-white w-full" style={{ height: wantsFull ? '100%' : innerHeight, zIndex: 10 }}>
        {children}
      </div>
    </div>
  );
};

// Responsive heights to match static PreviewCard
export function getResponsiveScreenHeight(mode?: "grid" | "full"): number {
  const GRID_SCREEN_HEIGHT = 720; // desktop (was 680)
  const GRID_SCREEN_HEIGHT_TABLET = 660; // md (was 620)
  const GRID_SCREEN_HEIGHT_MOBILE = 600; // sm (was 560)
  if (mode && mode !== "grid") return 640; // "full" default
  const vw = typeof window !== "undefined" ? window.innerWidth : 1200;
  if (vw <= 480) return GRID_SCREEN_HEIGHT_MOBILE;
  if (vw <= 900) return GRID_SCREEN_HEIGHT_TABLET;
  return GRID_SCREEN_HEIGHT;
}

export default PhoneBezel;
